import enAU from './i18n/locales/en-AU.json'
import enKE from './i18n/locales/en-KE.json'

const locale = import.meta.env.VITE_LOCALE || 'en-AU'
const localeData = locale === 'en-KE' ? enKE : enAU

export const brand = localeData.brand
